<template>
  <div class="footer">
    <div class="container">
      <div class="row">
        <div class="col-xl-6">
          <div class="links">
            <a href="https://ultimaker.com/" target="_blank">
              <p>Ultimaker</p>
            </a>
            <a href="https://ultimaker.com/legal/privacy-and-cookie-statement" target="_blank">
              <p>Privacy</p>
            </a>
            <a href="https://ultimaker.com/legal/privacy-and-cookie-statement" target="_blank">
              <p>Cookies</p>
            </a>
          </div>
          <div class="copyright">
            <p>Copyright &copy; {{ currentYear }} Ultimaker Summit. All Rights Reserved.</p>
          </div>
        </div>
        <div class="col-xl-6">
          <div class="poweredBy">
            <p>This Virtual Event is Powered by <a href="https://www.reydar.com/ar-solutions/virtual-events/" target="_blank"><span>Reydar</span></a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "siteFooter",
  data: () => ({
    currentYear: "2021",
  }),
  created() {
    this.currentYear = new Date().getFullYear()
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/Layout/Footer";
</style>
